import { useState } from 'react';

export function compressBase64Image(
  base64Str,
  maxWidth = 1200,
  quality = 0.7,
  maxSizeKB = 1000,
) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = base64Str;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      let { width, height } = img;

      // Helper function to calculate base64 size in KB
      const getBase64SizeKB = (base64) => {
        // Remove data URL prefix if present
        const base64Data = base64.split(',')[1] || base64;
        // Calculate actual size (base64 is ~4/3 of actual size)
        return (base64Data.length * 3) / 4 / 1024;
      };

      // Helper function to compress with given dimensions and quality
      const compress = (w, h, q) => {
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, w, h);
        return canvas.toDataURL('image/jpeg', q);
      };

      // Start with initial dimensions
      if (width > maxWidth) {
        height = (maxWidth / width) * height;
        width = maxWidth;
      }

      let currentQuality = quality;
      let currentWidth = width;
      let currentHeight = height;
      let compressedBase64 = compress(
        currentWidth,
        currentHeight,
        currentQuality,
      );
      let sizeKB = getBase64SizeKB(compressedBase64);

      // Iteratively reduce quality and/or dimensions until size is acceptable
      while (
        sizeKB > maxSizeKB &&
        (currentQuality > 0.1 || currentWidth > 100)
      ) {
        if (currentQuality > 0.3) {
          // First, reduce quality
          currentQuality -= 0.1;
        } else {
          // Then reduce dimensions
          currentWidth *= 0.9;
          currentHeight *= 0.9;
        }

        compressedBase64 = compress(
          Math.floor(currentWidth),
          Math.floor(currentHeight),
          currentQuality,
        );
        sizeKB = getBase64SizeKB(compressedBase64);
      }

      resolve(compressedBase64);
    };
    img.onerror = (err) => reject(err);
  });
}

export function useImagePreload(src) {
  const img = new Image();
  img.src = src;
}
